const pagesSoftwareEn = {
  add: {
    action: {
      addSoftware: 'Add Software',
      next: 'Next',
      optional: 'Optional'
    },
    body: {
      fillOutDetails: 'Fill out the details',
      itemCard: {
        requiredDetails: 'Required details:',
        requiredItem: 'Required item'
      },
      selectSoftwareType: 'Select the type:'
    },
    header: {
      headerTitle: 'Add software to your registry'
    },
    options: {
      bulkCsvUpload: {
        button: 'Upload CSV',
        description: 'You can add data for multiple software items, up to 500 records at a time. A CSV file following the DRESS CODE format is required.',
        selectedSoftwareType: 'Selected software type:',
        title: 'Bulk add by uploading a csv file'
      },
      description: 'Or you might want to...',
      logo: {
        fileReadError: 'Failed to read file',
        fileSizeError: 'File size must be less than 500KB'
      }
    },
    progress: {
      filled: 'Filled',
      required: 'Required Items',
      total: 'Total'
    },
    softwareTypes: {
      customSaas: 'Custom SaaS',
      installed: 'Installed',
      mwOs: 'MW • OS',
      product: 'Product',
      scratch: 'Scratch'
    },
    step: {
      architectureInformation: 'Architecture',
      basicInformation: 'Basic',
      detailedInformation: 'Detail',
      installedSoftwareInformation: 'Installed Software Information',
      responsibilityInformation: 'Responsibility',
      softwareIdInformation: 'Software ID Information',
      vendorInformation: 'Vendor'
    },
    toast: {
      addSoftwareError: 'Failed to add software',
      addSoftwareSuccess: 'Software added successfully',
      error: 'Error',
      inputError: 'Input Error',
      inputErrorDescription: 'Please check required fields',
      success: 'Success'
    }
  },
  alert: {
    actions: {
      editRole: 'Edit Role',
      openMenu: 'Open menu'
    },
    appCard: {
      goToProfile: 'Go To Profile'
    },
    bulkDeactivation: 'Bulk Deactivation',
    bulkProvision: 'Bulk Provision',
    errors: {
      packageNotFound: 'Package not found'
    },
    filter: {
      byApp: {
        name: 'Software',
        notFound: 'No software found',
        predicate: 'is',
        searchPlaceholder: 'Search software...'
      },
      freeText: 'Filter people...',
      toggleSummary: 'Show summary'
    },
    help: {
      alumni: {
        text: 'Accounts associated with former employees who have left the company.<br />Regular review and account deletion is recommended to avoid security risks.',
        title: 'Alumni?'
      },
      inactive: {
        text: 'Inactive refers to accounts that have no activity for more than 20 days. The detection of inactive accounts is only applicable to software that track last-usage timestamps.',
        title: 'Inactive?'
      },
      noUser: {
        text: 'No User lists people who should have been issued user accounts but currently do not have them.',
        title: 'No User?'
      },
      shadowIt: {
        text: 'These are access logs to software that is not connected to DRESS CODE, collected via the browser extension.<br />They are updated every hour, at the top of each hour.',
        title: 'Shadow IT?'
      },
      unidentified: {
        text: "Unidentified refers to a user account that is not linked to any person. The account is linked by either changing the account's email to match or assigning a person to the account",
        title: 'Unidentified?'
      },
      violatedAccountRole: {
        text: 'User accounts with roles that do not align with the assignment rule.',
        title: 'Violated Account Role?'
      },
      violatedAssignment: {
        text: 'Violated assignment refers to user accounts that exist despite not being permitted under the user assignment rules.',
        title: 'Violated Assignment?'
      }
    },
    pageTitle: 'software/alerts',
    shadowIt: {
      apps: {
        createCustomApp: 'Integrate as custom SaaS',
        freeText: 'Filter software...',
        integrate: 'Integrate',
        showDetail: 'Show detail'
      },
      details: 'Shadow IT details',
      integrateAsCustomApp: 'Integrate as custom SaaS',
      shadowId: 'Shadow Identity',
      title: 'Shadow IT',
      visitHistories: {
        freeText: 'Filter person by name, email...'
      }
    },
    sidebar: {
      accountRole: 'Account Role',
      accountState: 'Account Status',
      close: 'Close sidebar',
      open: 'Open sidebar',
      title: 'Alert categories'
    },
    tabs: {
      alumni: "Alumni's",
      inactive: 'Inactive',
      noUser: 'No User',
      noWorker: 'Unidentified',
      shadowIt: 'Shadow IT',
      violatedAssignment: 'Violated Assignment',
      violatedRole: 'Violated Account Role'
    }
  },
  contractAndCost: {
    costOverview: {
      table: {
        department: 'Department',
        fictitious: 'No entity',
        fraction: 'Rounding adjustment',
        item: 'Item',
        loadError: 'Failed to load cost data.',
        member: 'Member',
        memberCount: '{{count}} members',
        perUserPriceSuffix: '/ 1 {{userLabel}}',
        plan: 'Plan',
        rowType: {
          actual: 'Actual',
          averageUnitPrice: 'Unit price',
          billingModel: 'Billing model',
          quantity: 'User count',
          scheduled: 'Planned',
          targetContract: 'Target contract',
          variance: 'Variance'
        },
        software: 'Software',
        total: 'Total',
        trend: 'Trend',
        unassigned: 'No user',
        unknown: 'Unknown department',
        userLabel: 'User'
      }
    },
    paymentOverview: {
      table: {
        department: 'Department',
        fictitious: 'No entity',
        fraction: 'Rounding adjustment',
        item: 'Item',
        loadError: 'Failed to load payment data.',
        member: 'Member',
        memberCount: '{{count}} members',
        perUserPriceSuffix: '/ 1 {{userLabel}}',
        plan: 'Plan',
        rowType: {
          actual: 'Actual',
          averageUnitPrice: 'Unit price',
          billingModel: 'Billing model',
          quantity: 'User count',
          scheduled: 'Planned',
          targetContract: 'Target contract',
          variance: 'Variance'
        },
        software: 'Software',
        total: 'Total',
        trend: 'Trend',
        unassigned: 'No user',
        unknown: 'Unknown department',
        userLabel: 'User'
      }
    }
  },
  customSaas: {
    add: {
      fillOutDetails: 'Fill Out Details',
      form: {
        navigation: {
          common: {
            submitButtonLabel: 'Add Custom SaaS'
          },
          completeDialog: {
            additionalButton: 'Go to SaaS details',
            completeLinkButton: 'Continue to import user account data',
            message: 'Successfully added Custom SaaS!'
          },
          intro: {
            customSaasNameLabel: 'Custom SaaS Name',
            nameLabel: 'Name',
            pricingLabel: 'Pricing',
            saasCategoryLabel: 'SaaS Category'
          },
          step: {
            one: 'Define Custom SaaS',
            two: 'Register plan details'
          },
          step1: {
            customSaasNameLabel: 'Custom SaaS Name',
            customSaasNamePlaceholder: 'Enter custom SaaS name',
            fileSizeError: 'File size must be less than 1MB',
            saasCategoryLabel: 'SaaS Category',
            saasCategoryPlaceholder: 'Select Category...',
            saasLogoLabel: 'SaaS Logo',
            saasServiceUrlLabel: 'SaaS Service URL',
            saasServiceUrlPlaceholder: 'Enter URL',
            saasSuggestDescription: 'Might it be…',
            supplements: 'Additional Information',
            tenantNameLabel: 'Tenant Name',
            tenantNamePlaceholder: 'Enter tenant name',
            tenantNameTooltip: `This name is used to identify your company or organization.
Names already in use within the same software cannot be used.`,
            title: 'Define Custom SaaS'
          },
          step2: {
            fixedPricePlanLabel: 'Fixed price',
            freePlanLabel: 'Free',
            licenseBasedLabel: 'License based',
            licenseLabel: 'License',
            licenseOption: {
              sheetLimitLabel: 'Sheet limit',
              sheetLimitPlaceholder: 'Type number'
            },
            notLicenseBasedLabel: 'Not license based',
            planNameLabel: 'Plan Name',
            planNamePlaceholder: 'Enter plan name',
            planOption: {
              billingAnchorDateDescription: 'A billing anchor date is the specific day of the billing anchor date when recurring charges are processed. ',
              billingAnchorDateLabel: 'Billing anchor date',
              billingAnchorDatePlaceholder: 'Anchor date',
              billingCycleDescription: 'The recurring time period between billings for a subscription or service.',
              billingCycleLabel: 'Billing cycle',
              billingCyclePlaceholder: 'Select billing cycle...',
              costLabel: 'The cost or price per individual usage unit.',
              currencyLabel: 'Currency',
              currencyPlaceholder: 'Select currency...',
              priceLabel: 'Price',
              typeNumber: 'Type number',
              unitRateDescription: 'The cost or price per individual usage unit.',
              unitRateLabel: 'Unit rate',
              unitRatePlaceholder: 'Type number'
            },
            pricingLabel: 'Pricing',
            usageBasedPlanLabel: 'Usage based pricing (ex. per user, per license)'
          },
          title: 'Add Custom SaaS'
        }
      },
      intro: {
        header: {
          headerTitle: 'Add Custom SaaS'
        }
      },
      itemCard: {
        requiredDetails: 'Required Details',
        title_custom_saas: 'Custom SaaS'
      },
      selectCustomSaasType: 'Select Type'
    },
    billingCycle: {
      month: 'Month',
      year: 'Year'
    },
    importCsv: {
      checkValidColumn: {
        errors: 'Errors',
        warnings: 'Warnings'
      },
      completeDialog: {
        button: 'Go to software details',
        message: 'Successfully imported!'
      },
      navigation: {
        newUser: 'New user',
        title: "Import {{appName}}'s user account",
        updateExistingUser: 'Update existing user'
      }
    }
  },
  detail: {
    customSaasBadge: 'Custom SaaS'
  },
  edit: {
    toast: {
      updateSuccess: 'Update successful'
    }
  },
  integrations: {
    actions: {
      refresh: 'Sync'
    },
    status: {
      refresh: {
        inProgress: 'Refresh in progress...'
      }
    },
    toast: {
      refresh: {
        alreadyInProgress: 'Refresh already in progress',
        rateLimited: 'Rate limited, please try again later',
        triggered: 'Refresh triggered successfully'
      }
    }
  },
  library: {
    allCategories: 'ALL',
    back: 'Back',
    category: 'Category',
    detail: {
      addToRegistry: 'Add to Registry',
      addToRegistryDialog: {
        cancel: 'Cancel',
        category: 'Category',
        close: 'Close',
        columnItem: 'Item',
        columnValue: 'Value',
        continueToImportUserData: 'Continue to import user data',
        description: 'Please confirm the content to be saved.',
        goToSoftwareDetail: 'Go to software details',
        pricingPageUrl: 'Pricing Page URL',
        privacyPolicyUrl: 'Privacy Policy URL',
        save: 'Save',
        seeMore: 'See more',
        servicePageUrl: 'Service Page URL',
        softwareName: 'Software Name',
        softwareType: 'Software Type',
        successTitle: 'Successfully Added!',
        termsOfUseUrl: 'Terms of Use URL',
        title: 'Confirm save content'
      },
      allPlanAvailable: 'Available pricing plans: All',
      authInfo: 'Authentication Information',
      availablePlans: 'Available pricing plans: {{value}}',
      backToLibrary: 'Library',
      category: 'Category',
      contractInfo: 'Contract Information',
      functions: {
        manageUserGroups: 'Manage user groups',
        userCreate: 'Create users',
        userDeactivate: 'Suspend users',
        userList: 'List users'
      },
      integrate: 'Integrate',
      integrationNotSupported: 'Integration for this software is not yet supported.',
      integrationRequirements: 'You will need the following information to integrate:',
      website: 'WEBSITE',
      whatYouCanDo: 'What you can do'
    },
    integratable: 'Integratable',
    integratableOnly: 'Integratable Only',
    notIntegratable: 'Not Integratable',
    pageTitle: 'Library',
    searchPlaceholder: 'Search {{count, number}}+ software\u2026',
    searchResult: 'Search Result',
    searchSoftwarePlaceholder: 'Search Software...',
    softwaresTitle: '{{category}} Softwares',
    suggested: 'Popular',
    top: 'Top',
    viewAll: 'View all',
    viewMore: 'View more'
  },
  marketplace: {
    addCustomApp: 'Add Custom SaaS',
    addIntegrationAsCustomApp: 'Integrate as Custom SaaS',
    addIntegrationTitle: 'Add SaaS Integration',
    detailPage: {
      allPlanAvailable: 'Available pricing plans: All',
      authorizationInfo: 'Authentication Information',
      availablePlans: 'Available pricing plans: {{value}}',
      backButton: 'Marketplace',
      category: 'Category',
      contractInfo: 'Contract Information',
      functions: {
        manageUserGroups: 'User Group Management',
        userCreate: 'Account Creation',
        userDeactivate: 'Account Deactivation',
        userList: 'Account Visibility'
      },
      functionsGridTitle: 'Available Functions',
      information: 'The following information is required for integration',
      pageTitle: 'Marketplace / {{name}}',
      startIntegrationButton: 'Integrate',
      website: 'Website'
    },
    installAppDialog: {
      authentication: {
        description: 'Enter the authentication information required for SaaS integration.',
        title: 'Authentication Information'
      },
      cancelButton: 'Cancel',
      contract: {
        description: 'Enter contract-related information.',
        title: 'Contract Information'
      },
      contractAnchor: {
        description: 'Set the contract start date.',
        title: 'Contract Start Date'
      },
      description: 'Fill in the following items to start SaaS integration!',
      installButton: 'Start Integration',
      pricingPlan: {
        description: 'Select the pricing plan to use.',
        title: 'Pricing Plan'
      },
      title: 'Integrate {{appName}}'
    },
    notFound: 'Sorry, integration for this SaaS is not yet supported.',
    pageTitle: 'Marketplace',
    requestIntegration: 'Request',
    searchAppAllCategories: 'All',
    searchAppPlaceholder: 'Search by SaaS name',
    title: 'Marketplace'
  },
  options: {
    accessControlType: {
      oauth: 'OAuth',
      other: 'Other',
      saml: 'SAML',
      self: 'Self'
    },
    autoUpdateSetting: {
      disabled: 'Disabled',
      enabled: 'Enabled',
      manual: 'Manual'
    },
    deploymentMethod: {
      cloudBased: 'Cloud Based',
      hybrid: 'Hybrid',
      onPremise: 'On-Premise'
    },
    environment: {
      dev: 'Development',
      prod: 'Production',
      stg: 'Staging'
    },
    gdprCompliance: {
      compliant: 'Compliant',
      inProgress: 'In Progress',
      nonCompliant: 'Non Compliant'
    },
    installationMethod: {
      installer: 'Installer',
      manual: 'Manual',
      mdm: 'MDM'
    },
    instanceType: {
      dev: 'Development',
      onPremise: 'On-Premise',
      prod: 'Production',
      saasTenant: 'SaaS Tenant',
      test: 'Test'
    },
    patchStatus: {
      notPatched: 'Not Patched',
      patched: 'Patched',
      scheduled: 'Scheduled'
    },
    softwareCategory: {
      accountingFinance: 'Accounting & Finance',
      ai: 'AI',
      analytics: 'Analytics',
      communication: 'Communication',
      cs: 'CS',
      devOps: 'Dev & Ops',
      groupwareStorage: 'Groupware & Storage',
      hr: 'HR',
      knowledgeDocument: 'Knowledge & Document',
      legal: 'Legal',
      marketing: 'Marketing',
      operationWorkflow: 'Operation & Workflow',
      other: 'Other',
      productivity: 'Productivity',
      projectManagement: 'Project Management',
      research: 'Research',
      rpaIpaas: 'RPA & iPaaS',
      sales: 'Sales',
      securityCompliance: 'Security & Compliance',
      sustainabilityIr: 'Sustainability & IR',
      website: 'Website'
    },
    softwareType: {
      customSaas: 'Custom SaaS',
      installed: 'Installed',
      mwOs: 'MW & OS',
      product: 'Product',
      saas: 'SaaS',
      scratch: 'Scratch'
    },
    uninstallationMethod: {
      installer: 'Installer',
      manual: 'Manual',
      mdm: 'MDM'
    },
    usageStatus: {
      active: 'Active',
      deactivated: 'Deactivated',
      discontinued: 'Discontinued',
      trial: 'Trial',
      unknown: 'Unknown'
    }
  },
  overview: {
    cards: {
      awayMembersCard: {
        title: 'Alumni',
        unit: 'accounts'
      },
      inactiveUsersCard: {
        title: 'Inactive Users',
        unit: 'users'
      },
      integrationsCard: {
        label: 'New software from last month',
        title: 'Integrations',
        unit: 'softwares'
      },
      peopleCard: {
        noDepartment: '(No department)',
        title: 'People',
        unit: 'persons'
      },
      recentActivityCard: {
        title: 'Recent Activity',
        viewMore: 'View more'
      },
      upcomingRenewalsCard: {
        title: 'Upcoming Renewals',
        unit: 'in {{value}}'
      },
      usersCard: {
        title: 'Users',
        unit: 'users'
      }
    },
    pageTitle: 'software/overview'
  },
  people: {
    cards: {
      goToProfile: 'Go To Profile'
    },
    columns: {
      details: 'Details',
      noApps: 'No software',
      noDevices: 'No devices',
      showProfile: 'Show Profile'
    },
    filterPeoplePlaceholder: 'Filter by name...',
    filters: {
      app: 'Software',
      appCount: 'Software Count',
      clearAll: 'Clear all',
      clearFilter: 'Clear filter',
      clearSearch: 'Clear search',
      equalTo: 'equals to',
      export: 'Export',
      exportError: 'Export failed',
      exportSuccess: 'Export started successfully',
      exportTooltip: 'Export people data to CSV',
      filterLocationPlaceholder: 'Filter location...',
      filterOutput: '{{label}} <light>is</light> {{name}}',
      hasSomeApp: 'Has Some Software',
      isLessThan: 'is less than',
      isMoreThan: 'is more than',
      lessThan: 'less than',
      locationOfOffice: 'Location Of Office',
      model: 'Model',
      moreThan: 'more than',
      noResult: 'No results.',
      placePlaceholder: 'Search for work place',
      quantityFilterOutput: '{{label}} <light>{{text}}</light> {{amount}}',
      searchPlaceholder: 'Search for people...',
      selected: '{{value}} selected',
      softwarePlaceholder: 'Search for software',
      workerTypePlaceholder: 'Search for worker types'
    },
    pageTitle: 'software/people',
    tabs: {
      all: 'All',
      joined: 'Joined',
      joining: 'Joining',
      leaving: 'Leaving'
    }
  },
  productHeader: {
    pageTitle: 'Softwares'
  },
  profile: {
    activityMonitoring: {
      navigation: {
        accountAccessActivity: 'Account Access Activity',
        accountAccessAudit: 'Account Access Audit'
      },
      pageTitle: 'Activity Monitoring',
      sections: {
        accountAccessActivity: {
          pageTitle: 'Account Access Activity',
          table: {
            accountId: 'Account ID',
            activityDescription: 'Activity Description',
            activityType: 'Activity Type',
            deviceId: 'Device ID',
            ipAddress: 'IP Address'
          }
        },
        accountAccessAudit: {
          auditReviewStatus: 'Audit Review Status',
          pageTitle: 'Account Access Audit',
          reviewedAt: 'Reviewed at',
          reviewedBy: 'Reviewed by'
        }
      }
    },
    architecture: {
      navigation: {
        executionRequirements: 'Execution Requirements',
        installInformation: 'Install Information',
        securityCompliance: 'Security & Compliance',
        softwareComponent: 'Software Component',
        softwareDependency: 'Software Dependency',
        softwareInstance: 'Software Instance',
        uninstallInformation: 'Uninstall Information',
        versionBuildInformation: 'Version/Build Information'
      },
      pageTitle: 'Architecture',
      sections: {
        executionRequirements: {
          dependentSoftware: 'Dependent Software',
          executionMode: 'Execution Mode',
          pageTitle: 'Execution Requirements',
          requiredDiskSpace: 'Required Disk Space',
          requiredMemory: 'Required Memory'
        },
        installInformation: {
          installationDate: 'Installation Date',
          installationMediaInfo: 'Installation Media Info',
          installationMethod: 'Installation Method',
          installationPath: 'Installation Path',
          installedDevicesCount: 'Installed Devices Count',
          pageTitle: 'Install Information'
        },
        securityCompliance: {
          autoUpdateSetting: 'Auto Update Setting',
          pageTitle: 'Security & Compliance',
          requiresAdminPrivilege: 'Requires Admin Privilege',
          tamperDetectionEnabled: 'Tamper Detection Enabled',
          updateServerUrl: 'Update Server URL'
        },
        softwareComponent: {
          componentId: 'Component ID',
          componentName: 'Component Name',
          pageTitle: 'Software Component',
          repositoryUrl: 'Repository URL',
          runtime: 'Runtime'
        },
        softwareDependency: {
          dependencyId: 'Dependency ID',
          dependsOnId: 'Depends on ID',
          dependsOnType: 'Depends on Type',
          maxVersion: 'Max Version',
          minVersion: 'Min Version',
          pageTitle: 'Software Dependency',
          requiredFlag: 'Required Flag'
        },
        softwareInstance: {
          environment: 'Environment',
          instanceId: 'Instance ID',
          instanceType: 'Instance Type',
          linkedSystems: 'Linked Systems',
          pageTitle: 'Software Instance',
          region: 'Region',
          tenantDomain: 'Tenant Domain'
        },
        uninstallInformation: {
          pageTitle: 'Uninstall Information',
          uninstallationDate: 'Uninstallation Date',
          uninstallationMethod: 'Uninstallation Method',
          uninstallationReason: 'Uninstallation Reason',
          uninstalledBy: 'Uninstalled by'
        },
        versionBuildInformation: {
          buildNumber: 'Build Number',
          endOfSupportDate: 'End of Support Date',
          pageTitle: 'Version/Build Information',
          patchStatus: 'Patch Status',
          patchVersion: 'Patch Version',
          releaseDate: 'Release Date',
          version: 'Version',
          versionPolicy: 'Version Policy'
        }
      }
    },
    contractsCost: {
      navigation: {
        budgetCost: 'Budget & Cost',
        contractInformation: 'Contract Information',
        planInformation: 'Plan Information'
      },
      pageTitle: 'Contracts & Cost',
      sections: {
        budgetCost: {
          actualCost: 'Actual Cost',
          budgetedCost: 'Budgeted Cost',
          costCenter: 'Cost Center',
          costMonth: 'Cost Month',
          invoiceNumber: 'Invoice Number',
          pageTitle: 'Budget & Cost',
          taxRate: 'Tax Rate',
          varianceReason: 'Variance Reason'
        },
        contractInformation: {
          autoRenew: 'Auto Renew',
          billingCycle: 'Billing Cycle',
          cancellationDeadline: 'Cancellation Deadline',
          contractAmount: 'Contract Amount',
          contractEndDate: 'Contract End Date',
          contractFileUrl: 'Contract File URL',
          contractId: 'Contract ID',
          contractName: 'Contract Name',
          contractNotes: 'Contract Notes',
          contractStartDate: 'Contract Start Date',
          contractStatus: 'Contract Status',
          contractType: 'Contract Type',
          noticePeriod: 'Notice Period',
          pageTitle: 'Contract Information',
          paymentCurrency: 'Payment Currency',
          paymentMethod: 'Payment Method',
          paymentTerms: 'Payment Terms',
          renewalWindow: 'Renewal Window',
          supplierContact: 'Supplier Contact',
          supplierId: 'Supplier ID'
        },
        planInformation: {
          baseFee: 'Base Fee',
          currency: 'Currency',
          includedFeatures: 'Included Features',
          pageTitle: 'Plan Information',
          planCode: 'Plan Code',
          planId: 'Plan ID',
          planName: 'Plan Name',
          planNotes: 'Plan Notes',
          planType: 'Plan Type',
          pricingDriver: 'Pricing Driver',
          pricingModel: 'Pricing Model',
          unitPrice: 'Unit Price',
          usageLimit: 'Usage Limit',
          usageUnit: 'Usage Unit',
          variableFee: 'Variable Fee'
        }
      }
    },
    detail: {
      navigation: {
        compatibilityEnvironment: 'Compatibility & Environment',
        link: 'Link',
        maintenanceSupport: 'Maintenance & Support',
        operationalStatus: 'Operational Status',
        provisioningDistribution: 'Provisioning & Distribution',
        responsibility: 'Responsibility',
        securityCompliance: 'Security & Compliance',
        softwareIdInformation: 'Software ID Information',
        vendor: 'Vendor'
      },
      sections: {
        compatibilityEnvironment: {
          compatibleBrowsers: 'Compatible Browsers',
          pageTitle: 'Compatibility & Environment',
          requiredOs: 'Required OS',
          supportedLanguages: 'Supported Languages'
        },
        link: {
          pageTitle: 'Link',
          pricingPageUrl: 'Pricing Page URL',
          privacyPolicyUrl: 'Privacy Policy URL',
          servicePageUrl: 'Service Page URL',
          termsOfUseUrl: 'Terms Of Use URL'
        },
        maintenanceSupport: {
          pageTitle: 'Maintenance & Support',
          supportLevel: 'Support Level',
          updateFrequency: 'Update Frequency'
        },
        operationalStatus: {
          pageTitle: 'Operational Status',
          retirementDate: 'Retirement Date',
          usageStatus: 'Usage Status'
        },
        provisioningDistribution: {
          deploymentMethod: 'Deployment Method',
          linkedDeviceId: 'Linked Device ID',
          linkedSoftwareId: 'Linked Software ID',
          mdmManaged: 'MDM managed',
          pageTitle: 'Provisioning & Distribution',
          platformUsage: 'Platform Usage'
        },
        responsibility: {
          pageTitle: 'Responsibility',
          responsibleDepartment: 'Responsible Department',
          responsiblePersonId: 'Responsible Person ID',
          responsiblePersonName: 'Responsible Person Name'
        },
        securityCompliance: {
          accessControlType: 'Access Control Type',
          dataLocation: 'Data Location',
          gdprCompliance: 'GDPR Compliance',
          pageTitle: 'Security & Compliance',
          securityCertifications: 'Security Certifications'
        },
        softwareIdInformation: {
          category: 'Category',
          description: 'Description',
          logo: 'Logo',
          logoUnset: 'Not set',
          pageTitle: 'Software ID Information',
          softwareAlias: 'Software Alias',
          softwareId: 'Software ID',
          softwareName: 'Software Name',
          softwareType: 'Software Type'
        },
        vendor: {
          pageTitle: 'Vendor',
          vendorContact: 'Vendor Contact',
          vendorId: 'Vendor ID',
          vendorName: 'Vendor Name',
          vendorUrl: 'Vendor URL'
        }
      }
    }
  },
  registry: {
    actions: {
      delete: 'Delete Software',
      openMenu: 'Open menu'
    },
    addSoftwareButton: 'Add Integration Software',
    addSoftwareLabel: 'Add Software',
    columns: {
      integrationStatus: {
        integrated: 'Integrated',
        notIntegrated: 'Not Integrated'
      },
      monthOverMonth: 'MoM',
      pricingModel: {
        FIXED: 'Fixed',
        FREE: 'Free',
        HARDCODED: 'Unique',
        LINEAR: 'Linear',
        UNPREDICTABLE: 'Unpredictable'
      },
      renewalDate: {
        renewalDateIsWithinOneMonth: 'Renewal date is within one month'
      },
      saas: {
        customSaasBadge: 'Custom SaaS',
        noTenantName: '(No tenant name)'
      }
    },
    deleteSoftwareDialog: {
      cancelButton: 'Cancel',
      deleteButton: 'Delete',
      description: 'Are you sure you want to delete the following software?',
      successToast: 'Software deleted successfully',
      title: 'Delete Software',
      warning: 'This action cannot be undone.'
    },
    pageTitle: 'Software / Registry',
    search: {
      customSaas: 'Custom SaaS',
      placeholder: 'Filter software...'
    },
    tabs: {
      all: 'All',
      deactivated: 'Deactivated',
      installed: 'Installed',
      middlewareAndOs: 'MW & OS',
      product: 'Product',
      saas: 'SaaS',
      scratch: 'Scratch'
    }
  },
  settings: {
    integration: {
      title: 'Integration'
    },
    role: {
      addRole: 'Add account role',
      description: 'Account Roles define the permissions and access levels for users within this software. You can create custom account roles to manage user capabilities.',
      editRole: 'Edit {{name}}',
      form: {
        code: {
          description: 'Code must be unique within this software.',
          label: 'Code',
          placeholder: 'admin, user, viewer'
        },
        displayOrder: {
          description: {
            forAdd: 'If you do not input display order, default value 0 will be set.'
          },
          label: 'Display order',
          placeholder: '1'
        },
        name: {
          description: 'Role name should be unique within this software.',
          label: 'Name',
          placeholder: 'Admin, User, Viewer'
        }
      },
      searchPlaceholder: 'Search account roles',
      title: 'Account Role'
    },
    saml: {
      configured: {
        editAction: 'Edit',
        statusDisabled: 'Inactive',
        statusEnabled: 'Active'
      },
      delete: {
        action: 'Delete',
        confirmDescription: 'The SAML configuration will be deleted and the connected SaaS will no longer be able to sign in via SAML SSO.',
        confirmOk: 'Delete',
        confirmTitle: 'Delete SAML configuration?',
        success: 'SAML configuration deleted.',
        warningWhenEnabled: 'SSO is currently active. Deleting the SAML configuration will also automatically disable SSO, and users will no longer be able to sign in via SAML SSO.'
      },
      description: 'Configure DRESS CODE as a SAML Identity Provider (IdP) so users can sign in to this software via SAML single sign-on.',
      editDialog: {
        description: 'Enter the SAML Service Provider (SP) settings of the connected SaaS.',
        overwriteWarning: 'Saving will overwrite the current configuration with these values.',
        successCreate: 'SAML configuration saved.',
        successUpdate: 'SAML configuration updated.',
        titleCreate: 'Set up SAML SSO',
        titleEdit: 'Edit SAML SSO'
      },
      form: {
        acsUrls: {
          add: 'Add ACS URL',
          hint: 'The SP Assertion Consumer Service URL(s). HTTPS only (http allowed for localhost).',
          itemLabel: 'ACS URL #{{index}}',
          label: 'ACS URLs',
          placeholder: 'https://example.com/saml/acs',
          remove: 'Remove ACS URL #{{index}}'
        },
        advanced: {
          title: 'Advanced settings'
        },
        assertionTtlSeconds: {
          hint: 'Assertion validity period in seconds (60–86400).',
          label: 'Assertion lifetime (seconds)'
        },
        attributeMappings: {
          add: 'Add attribute',
          claim: {
            label: 'OIDC claim'
          },
          hint: 'Map OIDC claims (or static values) to the SAML attributes sent in the assertion.',
          label: 'Attribute mappings',
          nameFormat: {
            label: 'Name format (optional)',
            placeholder: 'urn:oasis:names:tc:SAML:2.0:attrname-format:basic'
          },
          remove: 'Remove attribute #{{index}}',
          samlAttribute: {
            label: 'SAML attribute #{{index}}',
            placeholder: 'e.g., Role',
            validation: 'Enter a SAML attribute name.'
          },
          source: {
            label: 'Source',
            options: {
              claim: 'OIDC claim',
              static: 'Static value'
            }
          },
          staticValue: {
            label: 'Static value',
            placeholder: 'e.g., member',
            validation: 'Enter a value.'
          }
        },
        audienceOverride: {
          hint: 'Specify only if the Audience should differ from the SP EntityID.',
          label: 'Audience override (optional)',
          placeholder: 'https://example.com/saml/metadata'
        },
        defaultAcsUrl: {
          hint: 'The ACS URL used by default. Must be one of the ACS URLs above.',
          label: 'Default ACS URL',
          placeholder: 'Select an ACS URL'
        },
        initiateLoginUrl: {
          hint: 'If left empty, the default URL is used.',
          label: 'Login URL',
          placeholder: 'https://example.com/login'
        },
        nameIdClaim: {
          label: 'NameID claim'
        },
        nameIdFormat: {
          label: 'NameID format',
          options: {
            emailAddress: 'Email address',
            persistent: 'Persistent',
            transient: 'Transient',
            unspecified: 'Unspecified'
          }
        },
        spEntityId: {
          hint: 'The Issuer / EntityID of the connected SaaS (SP).',
          label: 'SP EntityID',
          placeholder: 'https://example.com/saml/metadata'
        },
        spSigningCertPem: {
          hint: 'PEM certificate used to verify the SP-signed AuthnRequest.',
          label: 'SP signing certificate (PEM)',
          placeholder: '-----BEGIN CERTIFICATE-----'
        },
        validation: {
          atLeastOne: 'Enter at least one ACS URL.',
          httpsRequired: 'HTTPS is required (http only for localhost).',
          invalidNumber: 'Enter a valid number.',
          invalidUrl: 'Enter a valid URL.',
          notInAcs: 'Must match one of the ACS URLs.',
          outOfRange: 'Enter a value between 60 and 86400.',
          required: 'Required.',
          requiredWhenSigned: 'A certificate is required when requiring signed AuthnRequests.',
          tooLong: 'Too long.',
          unsupportedScheme: 'Only http:/https: are allowed.'
        },
        wantAuthnRequestsSigned: {
          description: 'Require the SP to sign its AuthnRequest, and verify it with the certificate below.',
          label: 'Require signed AuthnRequests'
        }
      },
      idpMetadata: {
        description: 'Register the following IdP metadata (EntityID / SSO URL / signing certificate) in your SaaS admin console.',
        download: 'Download metadata XML',
        title: 'DRESS CODE IdP information',
        urlLabel: 'IdP metadata URL'
      },
      loading: 'Loading SAML configuration...',
      notConfigured: {
        cta: 'Set up',
        description: 'SAML SSO is not configured yet. Set it up to let users sign in to this software via SAML.',
        title: 'SAML SSO is not configured'
      },
      summary: {
        acsUrlsCount: '{{total}} URL(s)',
        acsUrlsLabel: 'ACS URLs',
        assertionTtlLabel: 'Assertion lifetime',
        assertionTtlValue: '{{seconds}} seconds',
        attributeMappingsCount: '{{total}} mapping(s)',
        attributeMappingsLabel: 'Attribute mappings',
        audienceDefault: 'Same as SP EntityID',
        audienceLabel: 'Audience',
        defaultAcsUrlLabel: 'Default ACS URL',
        loginUrlDefault: 'Default URL',
        loginUrlLabel: 'Login URL',
        nameIdLabel: 'NameID',
        nameIdValue: '{{claim}} ({{format}})',
        signedNo: 'Not required',
        signedRequestsLabel: 'Signed AuthnRequests',
        signedYes: 'Required',
        spEntityIdLabel: 'SP EntityID'
      },
      title: 'SAML SSO',
      unsupported: {
        description: "This software's catalog does not support SAML. Contact your administrator if you need it.",
        title: 'SAML is not supported for this software'
      }
    },
    shared: {
      DeleteDialog: {
        cancelButton: 'Cancel',
        description: 'If this is used by any app users, you cannot delete it. This operation cannot be undone.',
        permanentlyDeleteButton: 'Permanently Delete',
        title: 'Delete {{name}}?'
      },
      actionsColumn: {
        deleteButton: 'Delete'
      }
    },
    sso: {
      authFreshness: {
        description: 'Decide whether to ask the user to sign in again based on how long ago they last authenticated.',
        options: {
          require: {
            description: 'If the specified time has passed since the last authentication, prompt the user to re-authenticate (for high-risk operations).',
            descriptionWithDuration: 'Require re-authentication if the last authentication was more than {{duration}} ago.',
            label: 'Require recent authentication'
          },
          trust: {
            description: 'Allow access while the session is valid, regardless of when the user last authenticated.',
            label: 'Trust existing session'
          }
        },
        title: 'Authentication freshness'
      },
      authStrength: {
        description: "Require a stronger sign-in method than your organization's default. If a user doesn't meet it, they're asked to sign in again with a stronger method.",
        mfaEnrollmentWarning: 'Requiring multi-factor authentication blocks users who have not enrolled in MFA from signing in to this integration. Check enrollment status for the affected users before enabling it.',
        options: {
          aal1: {
            label: 'Require single-factor authentication (aal1)'
          },
          aal2: {
            description: 'Requires completing two-factor authentication (such as an email code) at sign-in.',
            label: 'Require multi-factor authentication (MFA)'
          },
          default: {
            description: 'Trust the organization default authentication strength.',
            label: 'Use organization default'
          }
        },
        tip: 'You cannot select an authentication weaker than the organization default. Re-entering the same strength has no security benefit; only stronger methods are selectable.',
        title: 'Authentication strength'
      },
      clientSecretDialog: {
        clientId: 'Client ID',
        clientSecret: 'Client Secret',
        confirm: 'I saved the secret',
        description: 'Register the OIDC Issuer URL or Discovery URL (use whichever your external SaaS requires), along with the Client ID and Client Secret, in your SaaS SSO settings. Copy them now — the Client Secret cannot be retrieved again.',
        discoveryUrl: 'OIDC Discovery URL',
        discoveryUrlLoadError: 'Failed to load the OIDC Discovery URL. Try reloading or contact your administrator.',
        discoveryUrlLoading: 'Loading OIDC Discovery URL...',
        discoveryUrlRetry: 'Reload',
        issuerUrl: 'OIDC Issuer URL',
        title: 'Credentials generated',
        warning: 'The Client Secret is shown only once. After closing this dialog, you cannot view it again. Delete the Client and generate new credentials to issue a new Client Secret.'
      },
      deleteClient: {
        action: 'Delete',
        confirmDescription: 'The Client ID / Client Secret will be destroyed and the connected SaaS will no longer be able to use SSO. Re-issuing requires registering the new Client Secret on the SaaS side.',
        confirmOk: 'Delete',
        confirmTitle: 'Delete OAuth2 Client?',
        success: 'OAuth2 Client deleted.',
        warningWhenEnabled: 'SSO is currently active. Deleting the Client will also automatically disable SSO, and users will no longer be able to sign in via SSO.'
      },
      description: 'Configure SSO so users who signed in to DRESS CODE can access {{softwareName}} via single sign-on.',
      disable: {
        confirmDescription: 'Users will no longer be able to sign in via SSO. The OAuth2 Client (Client ID / Client Secret) is preserved, so you can re-enable with the same settings.',
        confirmOk: 'Disable SSO',
        confirmTitle: 'Disable SSO?',
        success: 'SSO disabled.'
      },
      duration: {
        days: '{{count}} days',
        hours: '{{count}} hours',
        minutes: '{{count}} minutes'
      },
      editDialog: {
        action: 'Edit',
        description: 'The Client Secret will be preserved. No reconfiguration on the SaaS side is required.',
        submit: 'Save',
        success: 'Client settings updated.',
        title: 'Edit OAuth2 Client settings'
      },
      enable: {
        toggleLabel: 'Single sign-on'
      },
      form: {
        actions: {
          cancel: 'Cancel'
        },
        authPolicy: {
          freshnessLabel: 'Freshness',
          strengthLabel: 'Strength'
        },
        clientName: {
          hint: 'Shown to end users on the consent screen.',
          label: 'Client name',
          placeholder: 'e.g., Slack Production',
          validation: 'Enter a name between 1 and 100 characters.'
        },
        initiateLoginUrl: {
          generatedHint: 'If left empty, the auto-generated URL will be used: {{ url }}',
          hint: 'URL users visit for SP-initiated login. Leave empty to use the auto-generated URL.',
          label: 'Login URL',
          noGeneratedHint: 'If left empty, no login link will be shown because tenant domain or product template is not configured.',
          placeholder: 'https://example.com/login',
          validation: {
            HTTPS_REQUIRED: 'HTTPS is required.',
            INVALID_URL: 'Enter a valid URL.',
            TOO_LONG: 'Must be at most 2048 characters.'
          }
        },
        maxAuthAgeMinutes: {
          label: 'Re-authentication period',
          validation: {
            outOfRange: 'Enter a value between 1 minute and 30 days (43200).'
          }
        },
        redirectUris: {
          add: 'Add Redirect URI',
          hint: 'URLs users return to after signing in. HTTPS only (http allowed for localhost).',
          label: 'Redirect URI #{{ index }}',
          placeholder: 'https://example.com/oauth/callback',
          remove: 'Remove Redirect URI #{{ index }}',
          title: 'Redirect URIs (optional, up to 10)',
          validation: {
            HTTPS_REQUIRED: 'HTTPS is required (http only for localhost).',
            INVALID_URL: 'Enter a valid URL.',
            NO_FRAGMENT: 'URLs must not contain a fragment (#).',
            UNSUPPORTED_SCHEME: 'Only http:/https: are allowed.'
          }
        },
        scope: {
          loadError: 'Failed to load scope options. Please reload the page.',
          loading: 'Loading scope options...',
          required: 'Required',
          title: 'Information shared with this software (scopes)',
          validation: 'Select at least one scope.'
        },
        sections: {
          authPolicy: 'Authentication policy',
          scope: 'Scopes'
        }
      },
      integrationSection: {
        clientIdLabel: 'Client ID',
        clientNameLabel: 'Client name',
        description: "Let users sign in to this software with their DRESS CODE account (single sign-on), so they don't need a separate password.",
        loginUrlLabel: 'Login URL',
        loginUrlManualOverride: 'Manual override',
        loginUrlNotSet: 'Not configured',
        notProvisionedDescription: 'Selecting "Generate credentials" creates the Client ID / Client Secret needed for the connection. SSO stays off right after generation, so you can review the settings before turning it on with the toggle.',
        notProvisionedTitle: 'No credentials generated yet',
        redirectUrisCount_one: '{{count}} registered',
        redirectUrisCount_other: '{{count}} registered',
        redirectUrisCount_zero: 'Not registered',
        redirectUrisLabel: 'Redirect URIs',
        statusOff: 'Inactive',
        statusOn: 'Active'
      },
      loading: 'Loading SSO configuration...',
      notConfigured: {
        cta: 'Set up',
        description: 'Configure single sign-on so users can sign in to this software with their DRESS CODE account.',
        title: 'SSO is not configured'
      },
      protocolChooser: {
        confirm: 'Next',
        description: 'Choose the SSO protocol to configure for this software.',
        oidc: {
          description: 'Issue an OAuth2 client (Client ID / Secret) for OIDC single sign-on.',
          label: 'OIDC'
        },
        saml: {
          description: 'Configure DRESS CODE as a SAML IdP for SAML single sign-on.',
          label: 'SAML'
        },
        title: 'Set up SSO'
      },
      provision: {
        cta: 'Generate credentials',
        description: 'Generates the Client ID / Client Secret needed for the connection. SSO stays off right after generation, so you can review the settings before turning it on with the toggle.',
        title: 'Generate credentials'
      },
      title: 'SSO',
      unavailable: 'This software does not support SSO integration.'
    },
    status: {
      addStatus: 'Add account status',
      badge: {
        isDeactivated: 'Deactivated',
        isInviting: 'Inviting'
      },
      column: {
        flags: 'Flags'
      },
      description: 'Account Statuses represent the current state of user accounts within this software. You can create custom account statuses to track user lifecycle.',
      editStatus: 'Edit {{name}}',
      form: {
        code: {
          description: 'Code must be unique within this software.',
          label: 'Code',
          placeholder: 'active, pending, suspended'
        },
        displayOrder: {
          description: {
            forAdd: 'If you do not input display order, default value 0 will be set.'
          },
          label: 'Display order',
          placeholder: '1'
        },
        isDeactivated: {
          label: 'This status indicates the user account is deactivated'
        },
        isInviting: {
          label: 'This status indicates the user is being invited'
        },
        name: {
          description: 'Status name should be unique within this software.',
          label: 'Name',
          placeholder: 'Active, Pending, Suspended'
        }
      },
      searchPlaceholder: 'Search account statuses',
      title: 'Account Status'
    }
  },
  accounts: {
    accountTypeBadge: {
      system: 'System account',
      user: 'User account'
    },
    addAccount: {
      button: 'Add Account',
      errors: {
        notReady: 'Bulk account provisioning is not available.'
      }
    },
    columns: {
      accountType: 'Account Type',
      appUser: 'App User',
      dcStatus: 'Status',
      email: 'Email',
      role: 'Account Role',
      saasStatus: 'Integration Status'
    },
    filterPlaceholder: 'Filter accounts...',
    tabs: {
      ACTIVE: 'Active',
      ALL: 'All',
      INVITED: 'Invited',
      SUSPENDED: 'Suspended'
    }
  },
  operationActivity: {
    filterByDate: 'Filter by date range',
    filterByPerson: 'Filter by person',
    filterBySoftware: 'Filter by software',
    pageTitle: 'Operation Activity',
    showSummary: 'Show Summary',
    summary: {
      accountCreate: 'Account Creation',
      accountDeactivate: 'Account Deactivation',
      events: 'events',
      targets: 'people',
      thisMonth: 'This Month',
      // accountRoleChange: "Account Role Change", // 未実装のためコメントアウト
      thisTerm: 'This Quarter',
      thisWeek: 'This Week'
    }
  },
  sso: {
    actions: {
      configure: 'Configure',
      openSettings: 'Open settings for {{name}}'
    },
    columns: {
      actions: 'Actions',
      clientName: 'Client Name',
      enabled: 'Enabled',
      protocol: 'Protocol',
      saas: 'SaaS',
      software: 'Software',
      sso: 'SSO',
      status: 'Status',
      supportedProtocols: 'Supported Protocols'
    },
    detail: {
      loadError: 'Failed to load SSO details.',
      loginUrl: 'Login URL',
      loginUrlConfigured: 'Configured',
      loginUrlGenerated: 'Generated',
      noLoginUrl: 'Not configured',
      oidc: {
        audience: 'Audience',
        clientId: 'Client ID',
        clientName: 'Client Name',
        grantTypes: 'Grant Types',
        postLogoutRedirectUris: 'Post-Logout Redirect URIs',
        redirectUris: 'Redirect URIs',
        responseTypes: 'Response Types',
        title: 'OIDC Configuration'
      },
      openSettings: 'Open Settings',
      policy: {
        oidc: {
          authFreshness: 'Authentication freshness',
          authStrength: 'Authentication strength',
          scope: 'Scopes',
          title: 'Scopes & authentication policy'
        },
        saml: {
          assertionTtl: 'Assertion lifetime',
          attributes: 'Shared attributes',
          attributesEmpty: 'No attribute mappings',
          authFreshness: 'Authentication freshness',
          authStrength: 'Authentication strength',
          nameId: 'NameID',
          nameIdValue: '{{claim}} ({{format}})',
          signedRequests: 'Signed AuthnRequests',
          title: 'Identity, shared attributes & authentication policy'
        }
      },
      retry: 'Retry',
      saml: {
        acsUrls: 'ACS URLs',
        assertionTtlValue: '{{seconds}} seconds',
        audience: 'Audience',
        audienceDefault: 'Same as SP Entity ID',
        certNotRegistered: 'Not Registered',
        certRegistered: 'Registered',
        defaultAcsUrl: 'Default ACS URL',
        hasSpSigningCert: 'SP Signing Certificate',
        mapping: {
          attribute: 'SAML Attribute',
          claim: 'OIDC Claim',
          empty: 'No attribute mappings registered',
          nameFormat: 'Name Format',
          source: 'Source',
          staticValue: 'Static Value',
          title: 'Attribute Mappings'
        },
        notRequired: 'Not Required',
        required: 'Required',
        spEntityId: 'SP Entity ID',
        title: 'SAML Configuration'
      },
      title: 'SSO Detail'
    },
    empty: 'No software found',
    emptyValue: '—',
    loadError: 'Failed to load the SSO list.',
    noTenant: '(No tenant name)',
    retry: 'Retry',
    status: {
      DISABLED: 'Disabled',
      ENABLED: 'Enabled',
      NOT_CONFIGURED: 'Not Configured'
    },
    title: 'Outbound SSO',
    toast: {
      disableSuccess: 'SSO disabled successfully',
      enableSuccess: 'SSO enabled successfully',
      error: 'Failed to toggle SSO'
    }
  }
};
export default pagesSoftwareEn;